module.exports = __webpack_public_path__ + "static/inconsolata-regular-webfont-445b8e596dc9f49beb007ba7a7093b2a.woff";